import { render, staticRenderFns } from "./base-form.vue?vue&type=template&id=7ca755fe&scoped=true"
import script from "./base-form.vue?vue&type=script&lang=ts&setup=true"
export * from "./base-form.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./base-form.vue?vue&type=style&index=0&id=7ca755fe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ca755fe",
  null
  
)

export default component.exports